import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { FindoSpinner } from "@/components/FindoSpinner";

export default function Reactivate() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [state, setState] = useState(token ? "loading" : "notoken");

  useEffect(() => {
    if (!token) return;
    (async () => {
      try {
        await api("/auth/reactivate", { method: "POST", body: { token }, auth: false });
        setState("success");
      } catch {
        setState("error");
      }
    })();
  }, [token]);

  return (
    <AuthShell title={t("hc.accountReactivation")} subtitle="Bon retour parmi nous sur findloop.">
      {state === "loading" && (
        <div className="text-center py-4" data-testid="reactivate-loading">
          <FindoSpinner size={36} className="mx-auto" />
          <p className="mt-4 text-slate-600">{t("hc.reactivating")}</p>
        </div>
      )}
      {state === "success" && (
        <div className="text-center py-2" data-testid="reactivate-success">
          <div className="mx-auto h-14 w-14 grid place-items-center rounded-2xl bg-teal-100 text-teal-700"><CheckCircle2 size={30} /></div>
          <p className="mt-4 text-slate-700 font-semibold">{t("hc.yourAccountHasBeenReactivated")}</p>
          <p className="mt-1 text-sm text-slate-500">{t("hc.logInToGetBack")}</p>
          <Button onClick={() => navigate("/auth/login")} className="mt-6 w-full h-11 rounded-xl font-semibold" data-testid="reactivate-login-btn">
            {t("hc.logIn")}
          </Button>
        </div>
      )}
      {(state === "error" || state === "notoken") && (
        <div className="text-center py-2" data-testid="reactivate-error">
          <div className="mx-auto h-14 w-14 grid place-items-center rounded-2xl bg-red-100 text-red-600"><XCircle size={30} /></div>
          <p className="mt-4 text-slate-700 font-semibold">{t("hc.invalidOrExpiredReactivationLink")}</p>
          <p className="mt-1 text-sm text-slate-500">{t("hc.theLinkMayHaveExpired")}</p>
          <Link to="/"><Button variant="outline" className="mt-6 w-full h-11 rounded-xl font-semibold">{t("hc.backToHome")}</Button></Link>
        </div>
      )}
    </AuthShell>
  );
}
